import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=8851c05c&scoped=true&lang=pug"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=8851c05c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8851c05c",
  null
  
)

export default component.exports